import { render, staticRenderFns } from "./StudentsAdd.vue?vue&type=template&id=5461ed84&"
import script from "./StudentsAdd.vue?vue&type=script&lang=ts&"
export * from "./StudentsAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports